export const ContactTitle = ({ children }: { children: React.ReactNode }) => {
    return <span className="fs-4 text-body fw-medium lh-sm text-wrap text-break">{children}</span>;
};
